/* ================================================================
   bm-coupon-capture.js
   Captura de e-mail com cupom — banda no corpo da página + popup
   (e a newsletter do footer, se um dia voltar a ser ligada).

   POR QUE O SUBMIT É NATIVO:
   A loja tem proteção antibot do Shopify nos formulários de cliente.
   O token de CAPTCHA só é injetado no fluxo de submit nativo — um
   envio por fetch com FormData cru é rejeitado com
   400 "Missing CAPTCHA token". Então nada de preventDefault aqui.

   As capturas fixas na página resolvem o sucesso em Liquid
   (form.posted_successfully?).
   O popup precisa deste JS porque some no reload: gravamos quem
   enviou e, ao voltar com ?customer_posted=true, reabrimos o popup
   já no estado de sucesso.
   ================================================================ */
(function () {
  if (window.__bmCouponCapture) return;
  window.__bmCouponCapture = true;

  var KEY_SUBSCRIBED = 'bm_cc_subscribed';
  var KEY_DISMISSED = 'bm_cc_dismissed_at';
  var KEY_SOURCE = 'bm_cc_source';
  var DISMISS_DAYS = 14;

  /* ── Storage tolerante (modo privado / cookies bloqueados) ──── */
  function read(store, key) {
    try {
      return window[store].getItem(key);
    } catch (_) {
      return null;
    }
  }

  function write(store, key, value) {
    try {
      window[store].setItem(key, value);
    } catch (_) {
      /* sem storage: o estado vale só para esta página */
    }
  }

  function drop(store, key) {
    try {
      window[store].removeItem(key);
    } catch (_) {}
  }

  function isSubscribed() {
    return read('localStorage', KEY_SUBSCRIBED) === '1';
  }

  function isDismissed() {
    var at = parseInt(read('localStorage', KEY_DISMISSED) || '0', 10);
    if (!at) return false;
    return Date.now() - at < DISMISS_DAYS * 24 * 60 * 60 * 1000;
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function justSubscribed() {
    return window.location.search.indexOf('customer_posted=true') !== -1;
  }

  /* ── Watchdog do hCaptcha ────────────────────────────────────
     Se o script do hCaptcha não carrega (adblocker, rede corporativa,
     extensão de privacidade), o submit nativo simplesmente não acontece:
     a pessoa clica e a página fica parada, sem erro nenhum. Depois de
     WATCHDOG_MS sem navegar, avisa em vez de deixar no vácuo. */
  var WATCHDOG_MS = 8000;

  function desafioAberto() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var box = frames[i].getBoundingClientRect();
      // O desafio visível é grande; os iframes invisíveis do hCaptcha são ~0
      if (box.width > 150 && box.height > 150) return true;
    }
    return false;
  }

  /* A banda de captura no corpo da página e o popup oferecem o mesmo
     cupom. Enquanto a banda está na tela, o popup espera: dois convites
     iguais ao mesmo tempo só atrapalham quem já ia preencher um deles. */
  function bandaNaTela() {
    var els = document.querySelectorAll('[data-bm-coupon-inline]');
    for (var i = 0; i < els.length; i++) {
      var box = els[i].getBoundingClientRect();
      if (box.bottom > 0 && box.top < window.innerHeight) return true;
    }
    return false;
  }

  function avisar(root) {
    var alvo = root.querySelector('[data-bm-cc-form-state]') || root;
    var box = alvo.querySelector('[data-bm-cc-watchdog]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'bm-cc__error';
      box.setAttribute('data-bm-cc-watchdog', '');
      box.setAttribute('role', 'status');
      var form = alvo.querySelector('form');
      if (form && form.parentNode) form.parentNode.insertBefore(box, form.nextSibling);
      else alvo.appendChild(box);
    }
    box.textContent = 'Não conseguimos concluir agora. Recarregue a página e tente de novo.';
  }

  /* Marca quem enviou, para saber o que reabrir depois do reload */
  function markSource(root, name) {
    var form = root.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function () {
      write('sessionStorage', KEY_SOURCE, name);
      // sem preventDefault: o CAPTCHA do Shopify depende do submit nativo

      var botao = form.querySelector('[type="submit"]');
      // aria-busy só como feedback; `disabled` aqui cancelaria o submit nativo
      if (botao) botao.setAttribute('aria-busy', 'true');

      var timer = window.setTimeout(function () {
        // Desafio visual aberto: a demora é legítima, a pessoa está resolvendo
        if (desafioAberto()) return;
        if (botao) botao.removeAttribute('aria-busy');
        avisar(root);
      }, WATCHDOG_MS);

      // Navegou: o envio deu certo e o aviso não deve existir
      window.addEventListener(
        'pagehide',
        function () {
          window.clearTimeout(timer);
        },
        { once: true }
      );
    });
  }

  /* ── Capturas fixas na página (banda no corpo, footer) ───────── */
  function initInline() {
    var roots = document.querySelectorAll('[data-bm-coupon-inline], [data-bm-coupon-footer]');
    for (var i = 0; i < roots.length; i++) {
      markSource(roots[i], roots[i].getAttribute('data-bm-cc-source') || 'footer');
    }
  }

  /* ── Popup ───────────────────────────────────────────────────── */
  function initPopup() {
    var root = document.querySelector('[data-bm-coupon-popup]');
    if (!root) return;

    // Escapa o stacking context da section — mesmo truque do bm-pro-access
    if (root.parentNode !== document.body) document.body.appendChild(root);

    markSource(root, 'popup');

    var panel = root.querySelector('[data-bm-cc-panel]');
    var lastFocus = null;

    function focusables() {
      return Array.prototype.slice.call(
        root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')
      );
    }

    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('bm-coupon-popup-open');
      if (panel) panel.focus();
    }

    function close() {
      if (root.hidden) return;
      root.hidden = true;
      document.body.classList.remove('bm-coupon-popup-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function dismiss() {
      // Fechou sem cadastrar: rearma em 14 dias
      if (!isSubscribed()) write('localStorage', KEY_DISMISSED, String(Date.now()));
      close();
    }

    root.querySelectorAll('[data-bm-cc-dismiss]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        dismiss();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* Theme Editor: abre ao selecionar a section, para dar pra editar */
    if (designMode()) {
      document.addEventListener('shopify:section:select', function (event) {
        if (event.target && event.target.contains(root)) open();
      });
      document.addEventListener('shopify:section:deselect', close);
      return;
    }

    /* Voltou do submit nativo com sucesso */
    if (justSubscribed()) {
      write('localStorage', KEY_SUBSCRIBED, '1');
      var veioDoPopup = read('sessionStorage', KEY_SOURCE) === 'popup';
      drop('sessionStorage', KEY_SOURCE);

      // Tira o parâmetro para um refresh não reabrir o sucesso do nada
      if (window.history.replaceState) {
        var limpa = window.location.pathname + window.location.hash;
        window.history.replaceState({}, '', limpa);
      }

      if (veioDoPopup) {
        var formState = root.querySelector('[data-bm-cc-form-state]');
        var success = root.querySelector('[data-bm-cc-success-state]');
        if (formState) formState.hidden = true;
        if (success) success.hidden = false;
        open();
        var code = root.querySelector('[data-bm-cc-success-state] [data-vh-copy-coupon]');
        if (code) code.focus();
      } else {
        root.remove();
      }
      return;
    }

    if (isSubscribed() || isDismissed()) {
      root.remove();
      return;
    }

    var path = window.location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) {
      root.remove();
      return;
    }

    /* Dispara em 8s OU 30% de scroll — o que vier primeiro, nunca antes de 5s */
    var armed = true;
    var floorPassed = false;
    var pending = false;

    function fire() {
      if (!armed) return;
      if (!floorPassed || bandaNaTela()) {
        pending = true;
        return;
      }
      armed = false;
      window.removeEventListener('scroll', onScroll);
      open();
    }

    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      if (window.scrollY / max >= 0.3) fire();
    }

    window.setTimeout(function () {
      floorPassed = true;
      if (pending) fire();
    }, 5000);

    window.setTimeout(fire, 8000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    initInline();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
